import WomenEmpowerment from "../../Images/OurWork/womenEmpowerment.jpg";
import Skills from "../../Images/OurWork/skills-2.png";
import Health from "../../Images/OurWork/health-wellbeing-2.png";
import Environment from "../../Images/OurWork/environment-3.png";

export const OurWorkData = [
  { title: "Livelihood & Skilling", link: "/Livelihood-skilling" },
  { title: " Health & Wellbeing", link: "/Health-Wellbeing" },
  { title: " Women Empowerment", link: "/Women-Empowerment" },
  {
    title: "Environment & Sustainability",
    link: "/Environment-Sustainability",
  },
];

export const AboutUsData = [
  { title: "Team", link: "/Team" },
  { title: "Advisory Board", link: "/AdvisoryBoard" },
  { title: "Governance", link: "/Governance" },
  {
    title: "Our Network",
    link: "/Our-Network",
  },
];

export const UsefulLinks = [
  { title: "Volunteer", link: "/Volunteer" },
  { title: "Donate Now", link: "/Donate-Now" },
  { title: " Contact Us", link: "/contact-us" },
  {
    title: "Terms & Conditions",
    link: "/t&c",
  },
];

export const fields = [
  {
    label: "First Name",
    name: "fName",
    type: "text",
    placeholder: "Enter your first name",
  },

  {
    label: "Last Name",
    name: "lName",
    type: "text",
    placeholder: "Enter your last name",
  },

  {
    label: " Mobile Number",
    name: "mobile",
    type: "tel",
    placeholder: "Enter your mobile number",
  },

  {
    label: "Email",
    name: "email",
    type: "email",
    placeholder: "Enter your email",
  },
];

export const CausesFields = [
  {
    title: "Livelihood & Skilling",
    desc: "  Lorem ipsum dolor amet consectetur adipisicing dolor magna aliqua elit sed eiusmod tempor incididunt labore dolor magna aliqua enim ad minimveniam quis nostrud exercita.",
    img: Skills,
    link: "/Livelihood-skilling",
  },

  {
    title: "Health & Wellbeing",
    desc: "  Lorem ipsum dolor amet consectetur adipisicing dolor magna aliqua elit sed eiusmod tempor incididunt labore dolor magna aliqua enim ad minimveniam quis nostrud exercita.",
    img: Health,
    link: "/Health-Wellbeing",
  },

  {
    title: " Women Empowerment",
    desc: "Lorem ipsum dolor amet consectetur adipisicing dolor magna aliqua elit sed eiusmod tempor incididunt labore dolor magna aliqua enim ad minimveniam quis nostrud exercita.",
    img: WomenEmpowerment,
    link: "/Women-Empowerment",
  },
  {
    title: "Environment & Sustainability",
    desc: "  Lorem ipsum dolor amet consectetur adipisicing dolor magna aliqua elit sed eiusmod tempor incididunt labore dolor magna aliqua enim ad minimveniam quis nostrud exercita.",
    img: Environment,
    link: "/Environment-Sustainability",
  },
];

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};
